"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configure = exports.rowHeaderColumn = void 0;
const _ = __importStar(require("lodash"));
const formatters = __importStar(require("./formatters"));
const editors = __importStar(require("./editors"));
const validators_1 = require("./validators");
const plugins = __importStar(require("./plugins"));
const columnFormatterCache_1 = require("./columnFormatterCache");
function rowHeaderColumn(options) {
    return {
        id: 'rowHeader',
        name: '#',
        field: '$idx',
        behavior: 'select',
        cssClass: 'row-header',
        width: 40,
        cannotTriggerInsert: true,
        resizable: false,
        selectable: false,
        sortable: false,
        filterable: false,
        frozen: true,
        systemColumn: true,
        noExport: true,
        formatter: (row, cell, value, columnDef, data) => {
            return (row + 1).toString();
        }
    };
}
exports.rowHeaderColumn = rowHeaderColumn;
function getCssClass(column) {
    const tokens = column.cssClass ? column.cssClass.split(' ') : [];
    if ((!column.textAlign && column.type === 'numeric') ||
        column.type === 'right') {
        tokens.push('align-right');
    }
    else if (!column.textAlign &&
        (column.type === 'date' || column.type === 'datetime')) {
        tokens.push('align-center');
    }
    else if (column.textAlign) {
        tokens.push(`align-${column.textAlign}`);
    }
    return tokens.join(' ').trim();
}
function configure(column, defaults) {
    if (column.type === 'rowHeader') {
        return rowHeaderColumn(column);
    }
    if (column.type === 'command') {
        column = new plugins.CommandColumn(column);
    }
    if (column.type !== 'rowHeader' && !column.field) {
        throw new TypeError('missing `field` configuration [slickg.column]');
    }
    if (column.type !== 'rowHeader' && column.id == null) {
        column.id = column.field;
    }
    column.formatter = (0, columnFormatterCache_1.columnFormatterCache)(formatters.getColumnFormatter(column), column);
    if (_.isString(column.editor)) {
        let editorFactory = editors[column.editor];
        if (!editorFactory) {
            throw new TypeError(`invalid editor: ${column.editor} [slickg.column]`);
        }
        column.editor = editorFactory(column);
    }
    if (column.validators) {
        if (_.isArray(column.validators)) {
            column.validator = (0, validators_1.createValidator)(...column.validators);
        }
        else if (_.isString(column.validators)) {
            column.validator = (0, validators_1.createValidator)(column.validators);
        }
    }
    if (!column.textAlign) {
        setTextAlign(column);
    }
    column.cssClass = getCssClass(column);
    if (defaults) {
        mergeInDefaults(column, defaults);
    }
    return column;
}
exports.configure = configure;
function mergeInDefaults(col, defaults) {
    _.each(defaults, (v, k) => {
        if (_.isUndefined(col[k])) {
            col[k] = v;
        }
    });
    return col;
}
function setTextAlign(column) {
    if (column.type && ['number', 'integer'].indexOf(column.type) > -1) {
        column.textAlign = 'right';
        return;
    }
    if (column.format && ['date', 'date-time'].indexOf(column.format) > -1) {
        column.textAlign = 'center';
    }
}
//# sourceMappingURL=columns.js.map